import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../baseQuery";

export const StudyDestinationApiSlice = createApi({
    reducerPath: "StudyDestinationApiSlice",
    baseQuery,

    tagTypes: ["destination", "pagination", "individual"],

    endpoints: (builder) => ({
        // Study destination and id based API
        getStudyDestinationApi: builder.query({
            query: (id) => ({
                url: `studyDestination/user/${id}`,
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["destination"]
        }),

        getStudyDestinationCountryTopUniversityApi: builder.query({
            query: ({ page = 1, limit = 3, id }) => ({
                url: `studyDestinationCountryTopUniversity/user-pagination/${id}`,
                method: 'GET',
                params: { page, limit },
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["pagination"]
        }),

        getStudyDestinationCountryTopUniversityIndividualUniversityApi: builder.query({
            query: (id) => (
                console.log("Fetching individual university with ID:", id),
                {
                url: `studyDestinationCountryTopUniversity/user/${id}`,
                method: 'GET',
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["individual"]
        }),

    }),
});

export const {
    useGetStudyDestinationApiQuery,
    useGetStudyDestinationCountryTopUniversityApiQuery,
    useGetStudyDestinationCountryTopUniversityIndividualUniversityApiQuery
} = StudyDestinationApiSlice; 